export default __webpack_public_path__ + "static/media/VRtour.071edbb3.webp";